import { CalendarContext } from './calendar-context'
import { CalendarEvent, CalendarLocation, CalendarPartner, CalendarVehicle, Mode, ReservationState } from './calendar-types'
import React, { useEffect, useState } from 'react'
import ReservationDetail from '../reservations/ReservationDetail'
import DatePickerDialog from './dialog/DatePickerDialog'

export default function CalendarProvider({
  events,
  setEvents,
  mode,
  setMode,
  date,
  setDate,
  calendarIconIsToday = true,
  children,
  locations,
  setLocations,
  partners,
  setPartners,
  vehicles,
  setVehicles,
  reservationStates,
  setReservationStates
}: {
  events: CalendarEvent[]
  setEvents: (events: CalendarEvent[]) => void
  mode: Mode
  setMode: (mode: Mode) => void
  date: Date
  setDate: (date: Date) => void
  locations: CalendarLocation[]
  setLocations: (locations: CalendarLocation[]) => void
  partners: CalendarPartner[]
  setPartners: (partners: CalendarPartner[]) => void
  vehicles: CalendarVehicle[]
  setVehicles: (vehicles: CalendarVehicle[]) => void,
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void,

  calendarIconIsToday: boolean
  children: React.ReactNode
}) {
  const [datePickerDialogOpen, setDatePickerDialogOpen] = useState(false)
  const [newEventDialogOpen, setNewEventDialogOpen] = useState(false)
  const [manageEventDialogOpen, setManageEventDialogOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null)

  useEffect(() => {
    setDatePickerDialogOpen(false)
  }, [date])

  return (
    <CalendarContext.Provider
      value={{
        events,
        setEvents,
        mode,
        setMode,
        date,
        setDate,
        calendarIconIsToday,
        datePickerDialogOpen, 
        setDatePickerDialogOpen,
        newEventDialogOpen,
        setNewEventDialogOpen,
        manageEventDialogOpen,
        setManageEventDialogOpen,
        selectedEvent,
        setSelectedEvent,
        locations,
        setLocations,
        partners,
        setPartners,
        vehicles,
        setVehicles,
        reservationStates,
        setReservationStates
      }}
    >
      <ReservationDetail open={manageEventDialogOpen} setOpen={setManageEventDialogOpen} row={selectedEvent as any} />
      {datePickerDialogOpen && <DatePickerDialog />}
      {children}
    </CalendarContext.Provider>
  )
}
